import { render, staticRenderFns } from "./TableInputProducts.vue?vue&type=template&id=1e57547b"
import script from "./TableInputProducts.vue?vue&type=script&lang=js"
export * from "./TableInputProducts.vue?vue&type=script&lang=js"
import style0 from "./TableInputProducts.vue?vue&type=style&index=0&id=1e57547b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports